<template>
    <div class="relative">
        <full-width-container class="bg-r-green relative lg:py-2 z-30">
            <content-container padding="px-3 py-2 lg:py-4 lg:px-12 z-30">
                <div
                    class="w-full flex flex-col lg:flex-row gap-5 md:justify-between md:items-center"
                >
                    <div class="flex flex-row justify-between items-center">
                        <h2
                            class="text-white font-black italic truncate flex-grow"
                        >
                            {{ $t("login_bar.title") }}
                        </h2>
                        <div
                            class="lg:hidden"
                            @click="showHamburgerMenu = !showHamburgerMenu"
                        >
                            <icon
                                :icon="
                                    showHamburgerMenu
                                        ? 'chevron-up'
                                        : 'chevron-down'
                                "
                                class="stroke-white w-8 h-8"
                            ></icon>
                        </div>
                    </div>

                    <div
                        v-if="showHamburgerMenu"
                        class="divide-y divide-white z-30"
                    >
                        <div
                            v-for="route in ['login', 'register']"
                            :key="route"
                            @click="
                                route.hasOwnProperty('click')
                                    ? route.click()
                                    : navigateItem({ name: route })
                            "
                            class="font-bold py-3 px-1"
                            :class="[
                                $route.name === route
                                    ? 'text-white underline underline-offset-4 decoration-2'
                                    : 'text-white',
                            ]"
                        >
                            {{ $t("login_bar." + route) }}
                        </div>
                    </div>

                    <div class="lg:flex-row items-center gap-8 hidden lg:flex">
                        <router-link
                            v-for="route in ['login', 'register']"
                            :key="route"
                            :to="{ name: route }"
                            class="font-bold text-white"
                            active-class="text-white underline underline-offset-4 decoration-2"
                        >
                            {{ $t("login_bar." + route) }}
                        </router-link>
                    </div>
                </div>
            </content-container>
        </full-width-container>
        <div
            @click="showHamburgerMenu = false"
            class="inset-0 fixed bg-r-black opacity-60 z-10 top-20 transition-all duration-300"
            v-if="showHamburgerMenu"
        ></div>
    </div>
</template>

<script>
import Logo from "@guest/layout/Logo";
import AppInput from "@guest/common/Input";
import AppButton from "@guest/common/Button";
import FullWidthContainer from "@guest/common/FullWidthContainer";
import ContentContainer from "@guest/common/ContentContainer";
import { mapActions, mapState } from "vuex";
import Icon from "@guest/common/Icon.vue";

export default {
    watch: {
        search: {
            handler: function (val) {
                console.log(val);
                this.$emit("input", val);
            },
            immediate: true,
        },
    },
    components: {
        Icon,
        Logo,
        AppInput,
        AppButton,
        FullWidthContainer,
        ContentContainer,
    },
    computed: {
        ...mapState({
            user: "profile",
        }),
    },
    methods: {
        ...mapActions({
            logout: "logout",
        }),
        navigateItem(target) {
            this.showHamburgerMenu = false;
            this.$router.push(target);
        },
    },
    data: function () {
        return {
            showHamburgerMenu: false,
            items: [
                {
                    icon: "calendar",
                    route: "bookings.list",
                    label: "navigation.my_reservations",
                },
                {
                    icon: "login",
                    route: "profile",
                    label: "navigation.profile",
                },
                {
                    icon: "cancel",
                    click: async () => {
                        await this.logout();
                        this.showHamburgerMenu = false;
                        this.$router.push({ name: "login" });
                    },
                    label: "navigation.logout",
                },
            ],
        };
    },
    mounted() {
        console.log("current route", this.$route);
    },
    props: {
        search: {
            type: String,
            required: false,
            default: null,
        },
    },
};
</script>

<style></style>
